/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserArrowDiagonalBottomRightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgklEQVR4nOWUPUoDURDHt/MEBgutcwJLC0UhSObjFZsZMAfwAJE0NnZ6AxsPkBDwCMGIF1DBEwQbFRU/QYzMkjUb1zUv2aRyYJr39s1v3n/+b4PgXwSRLCFLC1gfLZHlGDEsTq04kN4ia2845c72cgOQpZUu3k/SZm4ARJJkAFgeZgoA0vvcALSBZkokjfwADIs20HT3cuPc1mIwNZuSNk3zKEkaUys+07AugaQOrCfA0gXSD2T9NHlsDVl3J7pJqVSaQ5YDJHnNtuh3vgHpnn/xMJwH1jOPwr3Eg7v27ty3OJC+l0lqm2G44N19JIt357ITjBM2LE/Ne5bOVQt2DkiOgLVt0ibrRUqQnA4WSOrj6O5iAGu7P4eLJCT+LknsJH4BV6MAZZLawBRyHp+LZ/ILQLp9bZ/A6ZqPPYlkJQuSBpC+RO5gOUSsrPq4CLGyPphhtYAsl7FcKQCy7iPrc9lVlsHphr3YPwC2t/3TKHaTZPEhwKQx6t3kBpgVM2Vk7XwBqRnIuKjoDzkAAAAASUVORK5CYII=)
 */
export const UserArrowDiagonalBottomRightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11.53 11A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.26 2.61c-.02.3.2.55.5.55h7.67c.2 0 .4-.14.49-.33.22-.44.55-.83.95-1.12.3-.2.4-.65.14-.9l-.52-.53a3 3 0 0 1 2.43-5.1c.35.03.69-.21.69-.56v-.43a.49.49 0 0 0-.21-.4A9.49 9.49 0 0 0 12.47 11h-.94Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M24 17a1 1 0 1 0-2 0v3.59l-4.3-4.3a1 1 0 0 0-1.4 1.42L20.58 22H17a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1v-6Z"
        className={colorClass}
      />
    </svg>
  );
};
